class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.productId = document.querySelector('form[action="/cart/add"] [name="product-id"]').value;
      this.variantId = document.querySelector('form[action="/cart/add"] [name="id"]').value;
      this.BIS_trigger = document.getElementById('BIS_trigger') || document.getElementById('BIS_form_trigger');
      this.BIS_signup = document.getElementById('BIS_signup');
      this.BIS_feedback = document.getElementById('BIS_feedback');
      this.BIS_cookieNotice = this.BIS_signup?.querySelector('[data-third-party-cookie-notice]');
      this.variantsCount = this.getAttribute('data-variants-count');
      this.isGiftCard = this.getAttribute('data-is-gift-card') === 'true';
      this.SBIS_Img = document.getElementById("SBIS_img");
      this.SBIS_price = document.getElementById("SBIS_price");
      this.SBIS_sub_msg = document.getElementById("SBIS_sub_msg");
      this.SBIS_selected_variant = document.querySelector(".SBIS_selected_variant");
  
      this.addEventListener('change', this.onVariantChange);
      this.initBackInStock();
      this.selectSingleVariant();

      if(this.SBIS_selected_variant){
        try{
          const allVariants = this.getVariantData();
          const selectedVariant = allVariants.find(variant => variant.id == this.variantId);
          this.SBIS_selected_variant.innerText = selectedVariant.options[0];
        }
        catch(e){
          console.error("Error while setting selected variant for BIS info message.", e);
        }
      }
    }

    selectSingleVariant(){
      if(this.variantsCount == 1 && !window.location.href.includes("?variant=")){
        this.onVariantChange();
      }
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.selectGiftPopupVariant();
  
      this.updateBackInStock();

      if(this.SBIS_selected_variant && this.currentVariant && this.currentVariant.options.length){
        this.SBIS_selected_variant.innerText = this.currentVariant.options[0];
      }
  
      this.toggleAddButton(true, '', false);
      this.toggleSendGiftButton();
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
  
      this.dispatchEvent(
        new CustomEvent('variant-change', { bubbles: true, detail: { currentVariant: this.currentVariant } })
      );
    }

    selectGiftPopupVariant(){
      const giftPopupInput = document.querySelector("#gift-popup-id");
      if(giftPopupInput){
        giftPopupInput.value = this.variantId;
      }
    }
  
    initBackInStock() {
      if (!this.BIS_trigger || !this.BIS_signup) {
        return;
      }
  
      this.BIS_trigger?.addEventListener('click', (e) => {
        e.preventDefault();
        this.BIS_trigger.hidden = true;
        this.BIS_signup.hidden = false;
      });
      const formEl = this.BIS_signup.querySelector('form');
      formEl?.addEventListener('submit', (e) => {
        e.preventDefault();
        const email = formEl.email.value;
        const variantId = this.variantId;
        const productId = this.productId;
  
        if (!email || !variantId || !productId) {
          return;
        }
        //
        // Define the email address you want to subscribe to
        let mediumValue = email; // Email Address to subscribe
        let medium = "email"; // 'email' or 'sms'
        let topic = "backinstock" // the topic of "backinstock" configured at our backend.

        // Product data of the product
        let product = {
          epi: variantId, // unique variant ID of the product.
          empi: productId, // Product ID or master product ID
          du: window.routes.canonical_url, // canonical product url.
          iu: "https:" + this.SBIS_Img.value, // image url for email
          // pr: parseInt(this.SBIS_price.value), // price
        }

        // Success Callback
        let onSuccess = (response) => {
          console.log("Successfully Subscribed the email for the alert.", response);
          if (this.BIS_cookieNotice) {
            this.BIS_cookieNotice.hidden = true;
          }
          if (this.BIS_feedback) {
            this.BIS_feedback.classList.remove('form__message--rich-html');
            this.BIS_feedback.innerText = this.SBIS_sub_msg.value ?? "Thanks! We will notify you when this product becomes available!";
            this.BIS_feedback.hidden = false;
          } else {
            console.warn("BIS_feedback element not found.");
          }
        }
        
        // Error Callback
        let onError = (error) => {
          console.log("Error While subscribing the email for the alert.", error);
          if (this.BIS_cookieNotice) {
            this.BIS_cookieNotice.hidden = true;
          }
          if (this.BIS_feedback) {
            this.BIS_feedback.classList.remove('form__message--rich-html');
            this.BIS_feedback.innerText = "Error while subscribing the email for the alert. " + error;
            this.BIS_feedback.hidden = false;
          } else {
            console.warn("BIS_feedback element not found.");
          }
        }

        const swat = window._swat;
        const swatUnavailable =
          !swat || typeof swat.subscribeForProductAlert !== 'function';
        const preferencesCookiesDenied =
          typeof Shopify !== 'undefined' &&
          Shopify.customerPrivacy &&
          typeof Shopify.customerPrivacy.preferencesProcessingAllowed === 'function' &&
          Shopify.customerPrivacy.preferencesProcessingAllowed() === false;

        if (swatUnavailable && preferencesCookiesDenied) {
          if (this.BIS_cookieNotice) {
            this.BIS_cookieNotice.hidden = false;
          } else {
            console.warn("BIS cookie notice element not found.");
            onError(
              new Error(
                'Back in stock signup needs third-party cookie consent. Open cookie preferences via #reopenBanner.'
              )
            );
          }
        } else if (swatUnavailable) {
          onError(
            new Error(
              'Back in stock signup is unavailable (Swym could not be loaded).'
            )
          );
        } else {
          try {
            swat.subscribeForProductAlert(
              email,
              medium,
              product,
              onSuccess,
              onError,
              0,
              topic
            );
          } catch (e) {
            onError(e);
          }
        }
        //
        // BIS.create(email, variantId, productId).then(this.formFeedbackBackInStock.bind(this));
      });
    }

    //  callSwymBisMethod(mediumValue, medium, product, onSuccess,onError ,topic){
    //   debugger;
    //   try {
    //     const sbis_data = _swat.subscribeForProductAlert('d@.', medium, product, onSuccess,onError,0 ,topic);
    //     console.log(sbis_data);
    //   }
    //   catch(e) {
    //     console.log(e);
    //   }
    // }
  
    // formFeedbackBackInStock(data) {
    //   let msg = '';
  
    //   if (data.status == 'OK') {
    //     msg = data.message; // just show the success message
    //   } else {
    //     // it was an error
    //     for (var k in data.errors) {
    //       // collect all the error messages into a string
    //       msg += data.errors[k].join() + ' ';
    //     }
    //   }
    //   this.BIS_feedback.innerText = msg;
    //   this.BIS_feedback.hidden = false;
    // }
  
    updateBackInStock() {
      if (!this.BIS_trigger) {
        return;
      }
  
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = productForm?.querySelector('[name="add"]');
      if (this.BIS_signup) this.BIS_signup.hidden = true;
  
      if (this.currentVariant.available || !this.currentVariant) {
        this.BIS_trigger.hidden = true;
        document.body.classList.remove('is-bis-visible');
        addButton.hidden = false;
      } else {
        this.BIS_trigger.hidden = false;
        this.BIS_trigger.dataset.variantId = this.currentVariant.id;
        document.body.classList.add('is-bis-visible');
        addButton.hidden = true;
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
      this.variantId = this.currentVariant.id;
      window.currentVariant = this.currentVariant;
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
      );
  
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(':checked').value === variant.option1
      );
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
          this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
        }`
      )
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;
  
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const skuSource = html.getElementById(
            `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(
            `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
          const volumePricingSource = html.getElementById(
            `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
  
          const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
          const pricePerItemSource = html.getElementById(
            `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
  
          const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
          const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
          const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
  
          if (volumeNote) volumeNote.classList.remove('hidden');
          if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
          if (qtyRules) qtyRules.classList.remove('hidden');
  
          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
          }
  
          if (volumePricingSource && volumePricingDestination) {
            volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
          }
  
          if (pricePerItemSource && pricePerItemDestination) {
            pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
            pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
          }
  
          const price = document.getElementById(`price-${this.dataset.section}`);
  
          if (price) price.classList.remove('hidden');
  
          if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
  
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
          );
  
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          });
        });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        if(this.isGiftCard){
          addButtonText.textContent = window.variantStrings.giftAddToCart;
        }
        else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
        
      }
  
      if (!modifyClass) return;
    }

    toggleSendGiftButton(disable = false){
      const sendGiftBtn = document.querySelector("#send-gift-btn");
      if(sendGiftBtn){
        if(disable){
          sendGiftBtn.setAttribute("disabled", "disabled");
        }
        else {
          sendGiftBtn.removeAttribute("disabled");
        }
      }
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
      const sku = document.getElementById(`Sku-${this.dataset.section}`);
      const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
      const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
      const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
      const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
  
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('hidden');
      if (inventory) inventory.classList.add('hidden');
      if (sku) sku.classList.add('hidden');
      if (pricePerItem) pricePerItem.classList.add('hidden');
      if (volumeNote) volumeNote.classList.add('hidden');
      if (volumeTable) volumeTable.classList.add('hidden');
      if (qtyRules) qtyRules.classList.add('hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();  
    }
  
    selectSingleVariant(){
      if(this.variantsCount == 1 && !window.location.href.includes("?variant=")){
        const variantRadio = document.querySelector(`.product-form__input input[type="radio"]`);
        variantRadio?.click();
      }
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);